import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/i18nFormat";
import { PageHeader, LoadingBlock, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { ScrollText } from "lucide-react";

interface AuditItem {
  id: string; action: string; target_type?: string; target_id?: string;
  actor_user_id?: string; at: string; meta?: Record<string, any>;
}

export default function AuditLog() {
  const [items, setItems] = useState<AuditItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/audit?limit=100").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingBlock />;

  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Append-only record of material administrative actions" testId="audit-header" />
      {items.length === 0 ? (
        <EmptyState icon={<ScrollText size={28} />} title="No audit entries yet" />
      ) : (
        <Card className="overflow-hidden" data-testid="audit-table">
          {items.map((it) => (
            <div key={it.id} className="flex items-center justify-between gap-3 border-b border-border px-4 py-2.5 last:border-0 text-sm">
              <span className="font-mono text-xs text-brand">{it.action}</span>
              <span className="flex-1 truncate text-muted-foreground">{it.target_type}{it.target_id ? ` · ${it.target_id}` : ""}</span>
              <span className="text-xs text-muted-foreground">{fmtDateTime(it.at)}</span>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
